import { render } from "./Notice.vue?vue&type=template&id=4fe52432&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=4fe52432&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fe52432"

export default script